module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rateassist-location-details-tab-content"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPreCarriage),
      expression: "showPreCarriage"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "rate-assist-provider"
    }
  }, [_vm._v("Pre Carriage Locations")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": "Just start typing!",
      "placeHolder": "Select a Pre Carriage Location",
      "initVal": _vm.pc,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation,
      "autoFocus": true
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": function (location) { return _vm.addLocation('pc', 'preCarriage', 'PRE_CARRIAGE', location); }
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.preCarriage), function(l, i) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_vm._v("\n                " + _vm._s(_vm.displayLocation(l.location)) + "\n                "), _c('span', {
      staticClass: "pull-right"
    }, [_c('div', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.remove('preCarriage', i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOrigin),
      expression: "showOrigin"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "rate-assist-provider"
    }
  }, [_vm._v("Origin Locations")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": "Just start typing!",
      "placeHolder": "Select an Origin Location",
      "initVal": _vm.o,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation,
      "autoFocus": true
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": function (location) { return _vm.addLocation('o', 'origin', 'ORIGIN', location); }
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.origin), function(l, i) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_vm._v("\n                " + _vm._s(_vm.displayLocation(l.location)) + "\n                "), _c('span', {
      staticClass: "pull-right"
    }, [_c('div', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.remove('origin', i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDestination),
      expression: "showDestination"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "rate-assist-provider"
    }
  }, [_vm._v("Destination Locations")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": "Just start typing!",
      "placeHolder": "Select an Destination Location",
      "initVal": _vm.d,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation,
      "autoFocus": true
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": function (location) { return _vm.addLocation('d', 'destination', 'DESTINATION', location); }
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.destination), function(l, i) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_vm._v("\n                " + _vm._s(_vm.displayLocation(l.location)) + "\n                "), _c('span', {
      staticClass: "pull-right"
    }, [_c('div', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.remove('destination', i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOnCarriage),
      expression: "showOnCarriage"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "rate-assist-provider"
    }
  }, [_vm._v("On Carriage Locations")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": "Just start typing!",
      "placeHolder": "Select an On Carriage Location",
      "initVal": _vm.oc,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation,
      "autoFocus": true
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": function (location) { return _vm.addLocation('oc', 'onCarriage', 'ON_CARRIAGE', location); }
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.onCarriage), function(l, i) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_vm._v("\n                " + _vm._s(_vm.displayLocation(l.location)) + "\n                "), _c('span', {
      staticClass: "pull-right"
    }, [_c('div', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.remove('onCarriage', i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])])
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('blockquote', [_vm._v("\n        Locations\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3955bef6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/rateassist/components/LocationDetails.vue
// module id = 2152
// module chunks = 1